var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63.2946,
    height: 39.7884,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 39.7884,
    opacity: 0,
    width: 63.2946,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4796 39.7884C49.9521 39.7884 62.9431 24.6073 62.9431 19.9059C62.9431 15.1884 49.8851 0.0307031 31.4796 0.0307031C13.2286 0.0307031 0 15.1884 0 19.9059C0 24.6073 13.1688 39.7884 31.4796 39.7884ZM31.4796 36.8555C15.533 36.8555 3.22969 23.3414 3.22969 19.9059C3.22969 16.819 15.533 2.94915 31.4796 2.94915C47.385 2.94915 59.7206 16.819 59.7206 19.9059C59.7206 23.3414 47.385 36.8555 31.4796 36.8555ZM31.4796 33.0164C38.7251 33.0164 44.6208 27.0471 44.6208 19.9059C44.6208 12.5918 38.7251 6.80274 31.4796 6.80274C24.1655 6.80274 18.3061 12.5918 18.3061 19.9059C18.3061 27.0471 24.1655 33.0164 31.4796 33.0164ZM31.4941 24.0837C29.1511 24.0837 27.2477 22.2094 27.2477 19.9059C27.2477 17.5791 29.1511 15.7282 31.4941 15.7282C33.8065 15.7282 35.6953 17.5791 35.6953 19.9059C35.6953 22.2094 33.8065 24.0837 31.4941 24.0837Z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.c8b81fbadd17f71336c07e46775aa9c1.svg";
export { ForwardRef as ReactComponent };